import React from 'react';
import { Tabs, Card, Typography } from 'antd';
import ListAllInvoice from '../../components/Manage/Invoice/ListAllInvoice';


const InvoicePage = () => {
  return (
    <ListAllInvoice />
  );
};

export default InvoicePage;
